import { useActivity } from "PFCore/hooks/queries/activity";
import { Activity } from "PFTypes";

type UseActivityWithParent = {
  activityId: number | undefined;
};
type UseActivityWithParentReturn = {
  activity: Activity | undefined;
  parentActivity: Activity | undefined;
  isActivityFetching: boolean;
  isParentActivityFetching: boolean;
  isActivityError: boolean;
  isParentActivityError: boolean;
};

export const useActivityWithParent = ({ activityId }: UseActivityWithParent): UseActivityWithParentReturn => {
  const {
    data: activity,
    isFetching: isActivityFetching,
    isError: isActivityError
  } = useActivity(activityId ?? -1, {
    enabled: !!activityId,
    staleTime: Infinity
  });
  const {
    data: parentActivity,
    isFetching: isParentActivityFetching,
    isError: isParentActivityError
  } = useActivity(activity?.parent_activity_id ?? -1, {
    enabled: !!activity?.parent_activity_id,
    staleTime: Infinity
  });

  return {
    activity,
    parentActivity,
    isActivityFetching,
    isParentActivityFetching,
    isActivityError,
    isParentActivityError
  };
};
